// extracted by mini-css-extract-plugin
export default {"message":"ErrorGeneratingMessage_message__TGKOY"};